<div *ngIf="isPageLoading" class="loading-overlay">
  <div class="ups-spinner"></div>
</div>

<div *ngIf="!isPageLoading">
<div class="next-gen-home">

<div class="modal-overlay" *ngIf="showTncModal">
    <app-modal-tnc-next-gen 
        (accept)="handleTncAccept()" 
        (decline)="handleTncDecline()">
    </app-modal-tnc-next-gen>
</div>



<div class="dashboard-container">

<div class="next-gen-header">
    <img src="../../../../assets/icons/Logo.svg" alt="UPS Logo" class="ups-logo">
</div>

<h1 class="greeting headline-highlight">
      Hi, {{ companyName }}
    </h1>


  <div class="dashboard-header-content">
    <p><a href="https://www.ups.com/" class="back-link">&lt; Back to ups.com</a></p>
  </div>

  <div class="points-summary-cards">

    <div class="summary-card">
      <div class="card-content">
        <img src="../../../../assets/icons/ups-package-costs-rates.png" alt="Points Available Icon" class="card-icon">
        <span class="card-title">Points Available</span>
      </div>
      <div class="card-value-section">
         <span class="card-value">{{ pointsAvailable | number:'1.0-0' }}</span>
      </div>
    </div>

    <div class="summary-card">
      <div class="card-content">
        <img src="../../../../assets/icons/ups-volume-growth.png" alt="Points Earned Icon" class="card-icon">
        <span class="card-title">Points Earned</span>
      </div>
      <div class="card-value-section">
        <span class="card-value points-positive">+{{ pointsEarned | number:'1.0-0' }}</span>
      </div>
    </div>

    <div class="summary-card">
      <div class="card-content">
        <img src="../../../../assets/icons/ups-favorite.png" alt="Points Redeemed Icon" class="card-icon">
        <span class="card-title">Points Redeemed</span>
      </div>
      <div class="card-value-section">
        <span class="card-value points-negative">-{{ pointsRedeemed | number:'1.0-0' }}</span>
      </div>
    </div>

  </div>


<div class="points-container">
  <h2 class="card-title">My Points</h2>

  <mat-tab-group animationDuration="0ms" class="custom-tabs">
    
    <mat-tab class="tab-title" label="All">
      <div class="activity-list" [class.scroll-container]="isExpanded">
        <div class="activity-item" *ngFor="let item of (isExpanded ? allActivity : allActivity | slice:0:3)">
          <ng-container *ngTemplateOutlet="activityRow; context: { $implicit: item }"></ng-container>
        </div>
      </div>
    </mat-tab>

    <mat-tab class="tab-title" label="Points Earned">
      <div class="activity-list" [class.scroll-container]="isExpanded">
        <div class="activity-item" *ngFor="let item of (isExpanded ? earnedActivity : earnedActivity | slice:0:3)">
          <ng-container *ngTemplateOutlet="activityRow; context: { $implicit: item }"></ng-container>
        </div>
      </div>
    </mat-tab>

    <mat-tab class="tab-title" label="Points Redeemed">
      <div class="activity-list" [class.scroll-container]="isExpanded">
        <div class="activity-item" *ngFor="let item of (isExpanded ? redeemedActivity : redeemedActivity | slice:0:3)">
          <ng-container *ngTemplateOutlet="activityRow; context: { $implicit: item }"></ng-container>
        </div>
      </div>
    </mat-tab>

  </mat-tab-group>

  <!-- <div class="card-footer">
    <button class="btn-see-more" (click)="toggleView()">
      {{ isExpanded ? 'See Less' : 'See More' }} 
      
      <span class="chevron-down" [class.rotate-arrow]="isExpanded">&#8964;</span>
    </button>
  </div> -->

  <div class="card-footer">
  <button class="btn-see-more" (click)="toggleView()">
    {{ isExpanded ? 'See Less' : 'See More' }} 
    
    <span class="chevron-down" [class.rotate-arrow]="isExpanded"></span>
  </button>
</div>
</div>

<div class="apply-rewards-section">

  <app-apply-rewards (rewardApplied)="onRewardAppliedSuccess()" style="width:100%"></app-apply-rewards>
  </div>

<ng-template #activityRow let-item>
  <div class="item-left">
    <h3 class="item-title">{{ item.title }}</h3>
    <!-- <p class="item-id">{{ item.id }}</p> -->
    <p class="item-date">{{ item.date }}</p>
  </div>
  <div class="item-right">
    <span class="badge" [ngClass]="item.points > 0 ? 'badge-positive' : 'badge-negative'">
      {{ item.points > 0 ? '+' : '' }}{{ item.points }} Points
    </span>
    <i class="arrow-icon">&rsaquo;</i>
  </div>
</ng-template>


<div class="rewards-catalog-container">
  <h2 class="card-title">Rewards Catalog</h2>
  <div *ngIf="showMaritzError" class="maritz-error-banner">
    Something went wrong while connecting to the Rewards redemption site. Please try again or check back shortly.
  </div>

  <div class="rewards-grid">
    
    <div class="reward-card">
      <div class="card-image-wrapper">
        <img src="../../../../assets/icons/OutfitYourOffice_thumbnail.png" alt="Outfit Your Office" class="reward-img">
      </div>
      <h3 class="reward-title">Outfit Your Office</h3>
 <button class="btn-redeem" (click)="redirectToMaritz('OutfitYourOffice')">
  Redeem<span class="arrow"><img src="../../../assets/icons/icon_chevron_right.svg" alt="Arrow Right"></span>
</button>
    </div>

    <div class="reward-card">
      <div class="card-image-wrapper">
        <img src="../../../assets/icons/Maritz_Travel.png" alt="Business Travel" class="reward-img">
      </div>
      <h3 class="reward-title">Business Travel</h3>
      <button class="btn-redeem" (click)="redirectToMaritz('BusinessTravel')">
        Redeem<span class="arrow"><img src="../../../assets/icons/icon_chevron_right.svg" alt="Arrow Right"></span>
      </button>
    </div>

    <div class="reward-card">
      <div class="card-image-wrapper">
        <img src="../../../../assets/icons/RewardYourStaff_thumbnail.png" alt="Hard Work Deserves Hype" class="reward-img">
      </div>
      <h3 class="reward-title">Reward Yourself</h3>
      <button class="btn-redeem" (click)="redirectToMaritz('RewardYourself')">
        Redeem
        <span class="arrow"><img src="../../../assets/icons/icon_chevron_right.svg" alt="Arrow Right"></span></button>
    </div>

    <div class="reward-card">
      <div class="card-image-wrapper">
        <img src="../../../assets/icons/Maritz_Tools.png" alt="Tools for the Job" class="reward-img">
      </div>
      <h3 class="reward-title">Tools for the Job</h3>
      <button class="btn-redeem" (click)="redirectToMaritz('CelebrateYourStaff')">
        Redeem
        <span class="arrow"><img src="../../../assets/icons/icon_chevron_right.svg" alt="Arrow Right"></span></button>
    </div>

  </div>

<div class="catalog-footer">
  <button class="btn-browse-catalog" (click)="redirectToMaritz('BrowseFullCatalog')">
    Browse Full Catalog <span class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
  <mask id="mask0_1946_2808" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
    <rect width="18" height="18" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_1946_2808)">
    <path d="M6.99373 12.5212C6.83124 12.3687 6.75 12.1772 6.75 11.9467C6.75 11.7162 6.83124 11.5247 6.99373 11.3721L9.92015 8.625L6.99373 5.87788C6.83124 5.72534 6.75 5.53383 6.75 5.30334C6.75 5.07284 6.83124 4.88133 6.99373 4.7288C7.15622 4.57627 7.36023 4.5 7.60577 4.5C7.85131 4.5 8.05532 4.57627 8.21781 4.7288L11.7563 8.05046C11.8424 8.1313 11.9046 8.22032 11.9427 8.31751C11.9809 8.41471 12 8.5172 12 8.625C12 8.7328 11.9809 8.83529 11.9427 8.93249C11.9046 9.02968 11.8424 9.1187 11.7563 9.19954L8.21781 12.5212C8.05532 12.6737 7.85131 12.75 7.60577 12.75C7.36023 12.75 7.15622 12.6737 6.99373 12.5212Z" fill="#121212"/>
  </g>
</svg></span> </button>
</div>
</div>

<div class="reward-faq">
  <h2 class="card-title">FAQ</h2>

  <mat-accordion displayMode="flat" multi="true">
    
    <mat-expansion-panel 
      *ngFor="let item of (isFaqExpanded ? faqItems : faqItems | slice:0:5)" 
      [expanded]="item.isOpen"
      class="custom-expansion-panel">
      
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ item.question }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <p  [innerHTML]="item.answer" class="faq-answer">
      </p>

    </mat-expansion-panel>

  </mat-accordion>

  <div class="card-footer">
    <button class="btn-see-more" (click)="toggleFaqView()">
      {{ isFaqExpanded ? 'See Less' : 'See More' }} 
      <span class="chevron-down" [class.rotate-arrow]="isFaqExpanded"></span>
    </button>
  </div>

</div>

<div class="account-actions">
    <button class="btn-logout" (click)="handleLogout()">Log Out <span><svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none">
<path d="M0.243731 8.0212C0.0812438 7.86867 0 7.67716 0 7.44666C0 7.21617 0.0812438 7.02466 0.243731 6.87212L3.17015 4.125L0.243731 1.37788C0.0812438 1.22534 0 1.03383 0 0.803337C0 0.572842 0.0812438 0.38133 0.243731 0.228798C0.406218 0.0762661 0.610231 0 0.855769 0C1.10131 0 1.30532 0.0762661 1.46781 0.228798L5.00627 3.55046C5.0924 3.6313 5.15455 3.72032 5.19273 3.81751C5.23091 3.91471 5.25 4.0172 5.25 4.125C5.25 4.2328 5.23091 4.33529 5.19273 4.43249C5.15455 4.52968 5.0924 4.6187 5.00627 4.69954L1.46781 8.0212C1.30532 8.17373 1.10131 8.25 0.855769 8.25C0.610231 8.25 0.406218 8.17373 0.243731 8.0212Z" fill="#121212"/>
</svg></span></button>
    <button class="btn-unenroll" (click)="openUnenrollModal()">Unenroll <span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
  <mask id="mask0_1946_2864" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
    <rect width="18" height="18" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_1946_2864)">
    <path d="M6.99373 12.5212C6.83124 12.3687 6.75 12.1772 6.75 11.9467C6.75 11.7162 6.83124 11.5247 6.99373 11.3721L9.92015 8.625L6.99373 5.87788C6.83124 5.72534 6.75 5.53383 6.75 5.30334C6.75 5.07284 6.83124 4.88133 6.99373 4.7288C7.15622 4.57627 7.36023 4.5 7.60577 4.5C7.85131 4.5 8.05532 4.57627 8.21781 4.7288L11.7563 8.05046C11.8424 8.1313 11.9046 8.22032 11.9427 8.31751C11.9809 8.41471 12 8.5172 12 8.625C12 8.7328 11.9809 8.83529 11.9427 8.93249C11.9046 9.02968 11.8424 9.1187 11.7563 9.19954L8.21781 12.5212C8.05532 12.6737 7.85131 12.75 7.60577 12.75C7.36023 12.75 7.15622 12.6737 6.99373 12.5212Z" fill="white"/>
  </g>
</svg></span></button>
</div>

<!-- <div class="modal-overlay" *ngIf="showTncModal">
    <app-modal-tnc-next-gen (accept)="handleTncAccept()" (decline)="handleTncDecline()"></app-modal-tnc-next-gen>
</div> -->


</div>

<div class="modal-overlay" *ngIf="showUnenrollModal">
    <app-modal-unenroll-nextgen 
        (cancel)="closeUnenrollModal()" 
        (confirm)="handleUnenrollConfirm()">
    </app-modal-unenroll-nextgen>
</div>
</div>

</div>
